module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "appear": "",
      "name": "y-tag"
    },
    on: {
      "before-enter": _vm.beforeEnter
    }
  }, [(_vm.show) ? _c('span', {
    staticClass: "y-tag",
    class: _vm.type ? 'y-tag-' + _vm.type : ''
  }, [_vm._t("default"), _vm._v(" "), _c('y-svg', {
    staticClass: "close",
    attrs: {
      "type": "x",
      "width": 10
    },
    nativeOn: {
      "click": function($event) {
        _vm.del($event)
      }
    }
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-7ccdfd1a!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./components/components/tag/tag.vue
// module id = 487
// module chunks = 27